import { render } from "./UserSuperAdmin.vue?vue&type=template&id=ae7cc8b6&scoped=true"
import script from "./UserSuperAdmin.vue?vue&type=script&lang=js"
export * from "./UserSuperAdmin.vue?vue&type=script&lang=js"

import "./UserSuperAdmin.vue?vue&type=style&index=0&id=ae7cc8b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7cc8b6"]])

export default __exports__